import { message, Radio, Switch, Button, Pagination } from 'antd'
import { useEffect, useState } from 'react'
import {
  changeHomepageFloatStatus,
  changeHouseFloatStatus,
  changeSurveyStatus,
  checkConfig,
  getContactTable,
  getHomePageInfo,
  getHomepageFloatStatus,
  getHouseFloatStatus,
  getSurveyResult,
  getSurveyStatus,
} from '../../api/api'
import './index.css'
import ContactTable from './components/contactTable/contactTable'

export default function Homepage() {
  const [contactData, setContactData] = useState()
  const [total, setTotal] = useState()
  const [fresh, setFresh] = useState(false)
  const [payload, setPayload] = useState({ page: '1', pagesize: '10' })
  const [isPopUp, setIsPopUp] = useState(1)
  const [isHomeFloat, setIsHomeFloat] = useState(1)
  const [isHouseFloat, setIsHouseFloat] = useState(1)

  //excel是什么范围
  const [range, setRange] = useState(1)

  useEffect(() => {
    //开屏弹窗
    getSurveyStatus()
      .then((res) => {
        if (res.data.data.status === 0) {
          //设置审核（0表示未开启，1表示开启）
          console.log('开屏弹窗未开启')
          setIsPopUp(0)
        }
      })
      .catch((err) => {
        console.log(err)
      })

    //首页悬浮
    getHomepageFloatStatus()
      .then((res) => {
        if (res.data.data.status === 0) {
          //设置审核（0表示未开启，1表示开启）
          console.log('首页悬浮未开启')
          setIsHomeFloat(0)
        }
      })
      .catch((err) => {
        console.log(err)
      })

    //房源列表首页悬浮
    getHouseFloatStatus()
      .then((res) => {
        if (res.data.data.status === 0) {
          //设置审核（0表示未开启，1表示开启）
          console.log('房源列表页首页悬浮未开启')
          setIsHouseFloat(0)
        }
      })
      .catch((err) => {
        console.log(err)
      })
  }, [])

  useEffect(() => {
    //获取联系人table
    getContactTable({ params: payload }).then((res) => {
      setContactData(res.data.data.rows)
      setTotal(res.data.data.total)
    })
  }, [fresh, payload])

  const change = (key) => (value) => {
    console.log(value, key)
    switch (key) {
      case 1:
        changeSurveyStatus({ status: Number(value) }).then((res) => {
          if (value) {
            message.success('开屏弹窗已打开')
          } else {
            message.success('开屏弹窗已关闭')
          }
        })
        break
      case 2:
        changeHomepageFloatStatus({ status: Number(value) }).then((res) => {
          if (value) {
            message.success('首页悬浮已打开')
          } else {
            message.success('首页悬浮已关闭')
          }
        })
        break
      case 3:
        changeHouseFloatStatus({ status: Number(value) }).then((res) => {
          if (value) {
            message.success('房源列表页悬浮已打开')
          } else {
            message.success('房源列表页悬浮已关闭')
          }
        })
        break
      default:
        break
    }
  }

  const pageChange = (e) => {
    setPayload({
      ...payload,
      page: e,
    })
  }

  const getRange = (e) => {
    setRange(e.target.value)
  }

  const handleDownload = () => {
    getSurveyResult(range).then((res) => {
      let DownloadLink = document.createElement('a')
      DownloadLink.style = 'display: none' // 创建一个隐藏的a标签
      DownloadLink.download = '用户测试数据结果'
      DownloadLink.href = res.data.data.file
      document.body.appendChild(DownloadLink)
      DownloadLink.click() // 触发a标签的click事件
      document.body.removeChild(DownloadLink)
    })
  }

  return (
    <div>
      <div className="eventManage">
        <div>
          <div className="headTitle">广告活动入口开关</div>
          <div className="switch">
            <div>
              <span className="title">开屏弹窗:</span>
              <Switch
                key={isPopUp} //在初始化时可以刷新初始状态
                checkedChildren="开"
                unCheckedChildren="关"
                defaultChecked={isPopUp === 1 ? true : false}
                onChange={change(1)}
              />
            </div>
            <div>
              <span className="title">首页悬浮:</span>
              <Switch
                key={isHomeFloat} //在初始化时可以刷新初始状态
                checkedChildren="开"
                unCheckedChildren="关"
                defaultChecked={isHomeFloat === 1 ? true : false}
                onChange={change(2)}
              />
            </div>
            <div>
              <span className="title">房源列表页首页悬浮:</span>
              <Switch
                key={isHouseFloat} //在初始化时可以刷新初始状态
                checkedChildren="开"
                unCheckedChildren="关"
                defaultChecked={isHouseFloat === 1 ? true : false}
                onChange={change(3)}
              />
            </div>
          </div>
        </div>
      </div>

      <div className="eventManage">
        <div>
          <div className="headTitle">用户测试数据结果</div>
          <div className="switch">
            <div>
              <span className="title" style={{ margin: 20 }}>
                数据范围:
              </span>
              <Radio.Group onChange={getRange} value={range}>
                <Radio value={1}>近30天</Radio>
                <Radio value={0}>全部</Radio>
              </Radio.Group>
              <Button type="primary" onClick={handleDownload}>
                下载excel
              </Button>
            </div>
          </div>
        </div>
      </div>

      <div className="eventManage">
        <ContactTable data={contactData} setFresh={setFresh} />
        <Pagination
          showQuickJumper
          style={{ textAlign: 'right', padding: '20px' }}
          onChange={pageChange}
          total={total}
          key={total}
          pageSize={10}
          // current={1}
          defaultCurrent={1}
          showTotal={(total, range) =>
            `共${total}条记录, 第${range[0]}-${range[1]}条`
          }
        />
      </div>
    </div>
  )
}
